export default __webpack_public_path__ + "static/media/carousel3.314a4190.png";